module.exports = __webpack_public_path__ + "img/COVID-19-Response-650x340.43a8ee71.png";